export default "__VITE_ASSET__BZpDrtBN__"